import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import SettingsModal from "../Components/Modals/SettingsModal";

type Props = NativeStackScreenProps<RootStackParamList, "Settings">;

const SettingsScreen: React.FC<Props> = ({ navigation }) => {
  return <SettingsModal onClose={() => navigation.goBack()} />;
};

export default SettingsScreen;
